// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1OHHs","filesListContainer":"PosDisputesFiles_filesListContainer__hpm9F","filesButton":"PosDisputesFiles_filesButton__ungyY"};